
export const isQuizTaken = (studentId, quizMarksList) => {
    return quizMarksList.some(quiz => quiz.student_id === studentId);
  };